import React, { useEffect, useState } from "react";
import { Collapse, Radio, RadioChangeEvent, Input, Typography, Flex } from "antd";
import { toast } from "react-toastify";
import { customLogger } from "../../../utils/Logger";
import ENDPOINTS from "../../../services/endpoint";
import apiInstance from "../../../services/apiService";
import SettingsSidebarHeader from "../../../components/common/SettingsSidebarHeader";
import GradientButton from "../../../components/common/UI/GradientButton";
import CustomLoader from "../../../components/common/UI/Loader";
import "./index.scss";

// const { Text } = Typography;

interface OutgoingCallsProps {
  handleBackToPrevious: () => void;
}

// interface CallerIdNumber {
//   isCallerIdNumber: boolean;
//   phoneNumber: string;
//   _id: string;
// }

interface CallerIdName {
  customCallerName: string;
  isSelected: boolean;
  option: number;
  value: string;
}

const OutgoingCalls: React.FC<OutgoingCallsProps> = ({
  handleBackToPrevious,
}) => {
  const [loading, setLoading] = useState(false);
  // const [callersNumbersList, setCallersNumberList] = useState<CallerIdNumber[]>(
  //   []
  // );
  const [callerIDNamesList, setCallerIDNamesList] = useState<CallerIdName[]>(
    []
  );
  const [namesLoading, setNamesLoading] = useState(false);
  const [customCallerNameInput, setCustomCallerNameInput] = useState("");
  const [selectedNameOption, setSelectedNameOption] = useState("");

  const customHeader = (title: string, end: any) => (
    <div className="custom-header">
      <GradientButton className="option-icon">ID</GradientButton>
      <span>{title}</span>
      <span className="end-text">{end}</span>
    </div>
  );

  // const getCallerIdNumbers = async () => {
  //   const url = ENDPOINTS.CALLER_ID_NUMBERS;

  //   setLoading(true);

  //   try {
  //     const response = await apiInstance.get(url);
  //     const data = response.data.data;
  //     // debugger;
  //     setCallersNumberList(data);
  //   } catch (error) {
  //     customLogger(error);
  //     toast.error("Failed to fetch Outbound Caller Id Numbers");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getCallerIdNamesList = async () => {
    const url = ENDPOINTS.CALLER_ID_NAMES;

    setLoading(true);
    setNamesLoading(true);
    try {
      const response = await apiInstance.get(url);
      const data = response.data.data;
      setCallerIDNamesList(data);
      setCustomCallerNameInput(data[1]?.customCallerName);
      setSelectedNameOption(
        data.find((number: any) => number.isSelected)?.value || ""
      );
    } catch (error) {
      customLogger(error);
      toast.error("Failed to fetch Outbound Caller Id Names");
    } finally {
      setLoading(false);
      setNamesLoading(false);
    }
  };

  // const handleCallerIdNumberChange = async (e: RadioChangeEvent) => {
  //   const value = e.target.value;
  //   if (!value) return;

  //   const url = ENDPOINTS.CALLER_ID_NUMBERS;

  //   setLoading(true);

  //   try {
  //     const response = await apiInstance.post(url, {
  //       phoneId: value,
  //     });
  //     if (response.status === 200) {
  //       toast.success("Outbound callerId numbers updated successfully");
  //       getCallerIdNumbers();
  //     }
  //   } catch (error) {
  //     customLogger(error);
  //     toast.error("Could not update. Please try again");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleCallerIdNameChange = async (e: RadioChangeEvent) => {
    const value = e.target.value;
    if (!value) return;

    if (value.toLowerCase() === "customize") {
      setSelectedNameOption(value);
    } else {
      const url = ENDPOINTS.CALLER_ID_NAMES;

      setLoading(true);

      try {
        const response = await apiInstance.post(url, {
          option: 1,
        });
        if (response.status === 200) {
          toast.success("Outbound callerId numbers updated successfully");
          setSelectedNameOption(value);
          getCallerIdNamesList();
        }
      } catch (error) {
        customLogger(error);
        toast.error("Could not update. Please try again");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSave = async () => {
    if (!customCallerNameInput) {
      toast.error("Please enter a valid name");
      return;
    }

    const url = ENDPOINTS.CALLER_ID_NAMES;

    setLoading(true);

    try {
      const response = await apiInstance.post(url, {
        option: 2,
        customCallerName: customCallerNameInput,
      });

      if (response.status === 200) {
        toast.success("Outbound callerId numbers updated successfully");
      }
    } catch (error) {
      customLogger(error);
      toast.error("Could not update. Please try again");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // getCallerIdNumbers();
    getCallerIdNamesList();
  }, []);

  return (
    <>
      <div className="outgoing-calls-container">
        <SettingsSidebarHeader
          title="Outgoing Calls"
          handleBackClick={handleBackToPrevious}
        />

        <div className="options-container">
          <Collapse
            expandIconPosition="end"
            className="custom-collapse"
            items={[
              {
                key: "1",
                label: customHeader("caller ID Name", ""),
                children: namesLoading ? (
                  <Flex justify="center" align="center">
                    <CustomLoader />
                  </Flex>
                ) : (
                  <Radio.Group
                    disabled={loading}
                    onChange={(e) => handleCallerIdNameChange(e)}
                    className="callerid-name-radio-group"
                    value={selectedNameOption}
                  >
                    <Radio
                      className="custom-radio"
                      value={callerIDNamesList[0]?.value}
                    >
                      {callerIDNamesList[0]?.value}
                    </Radio>

                    <Radio
                      className="custom-radio"
                      value={callerIDNamesList[1]?.value}
                    >
                      <div className="input-container">
                        <Input
                          className="input"
                          readOnly={
                            selectedNameOption.toLowerCase() !== "customize"
                          }
                          value={customCallerNameInput}
                          onChange={(e) =>
                            setCustomCallerNameInput(e.target.value)
                          }
                          placeholder="Customize"
                        />
                        <GradientButton
                          disabled={loading}
                          onClick={handleSave}
                          className="save-btn"
                        >
                          Save
                        </GradientButton>
                      </div>
                    </Radio>
                  </Radio.Group>
                ),
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};

export default OutgoingCalls;
